import React from "react";

import "./footerup.scss";

const footerup = () => {
  return (
    <div className="footerup1">
      <div className="container-footer">
        <div className="desk1">
          <h1>Visit Us!</h1>
          <div className="alamat">
            Jl. Raya Kota Wisata, Ciangsana, Kec. Gn. Putri, Kabupaten Bogor,
            Jawa Barat 16968
          </div>
        </div>
        <hr />
        <div className="desk2">
          Dapatkan Informasi Promo, Brosur dan Pricelist Terbaru
        </div>
        <hr />
        <div className="desk3">Contact Us: +6281325283186 (Reza)</div>
      </div>

      <a href="/privacy-policy">Privacy Policy </a>
      <div className="copyright">
        © All Rights Reserved, Kota Wisata Cibubur
      </div>
      <div className="powered">Powered by Linktown</div>
    </div>
  );
};

export default footerup;
